import { getUserOrgDeals } from 'api/deals.api';
import { getOrgInvestors } from 'api/investors.api';
import { $list, $view } from 'signals/global.signals';
import displayError from 'utils/displayError';

export const fetchAndSetInvestorData = async () => {
  $view.update({ isTableLoading: true });
  try {
    const [{ data: deals }, { data }] = await Promise.all([
      getUserOrgDeals(),
      getOrgInvestors(),
    ]);
    const dealOptions = deals.map((deal) => ({
      label: deal.name,
      value: deal.id,
    }));
    $view.update({ dealOptions });

    $list.update({
      data,
    });
  } catch (error) {
    displayError({
      message: 'Failed to load investor data. Please refresh the page.',
      title: 'Loading Error',
    });
  } finally {
    $view.update({ isTableLoading: false });
  }
};
